import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { OtherDeductionsStyled } from '../../../asset/styled/deductions/OtherDeductionsStyled';

import titleImg from '../../../asset/img/otherdeduction_title_img.svg';

import InfoBanner from '../../../components/Banner';
import SubTitleSection from '../../../components/SubTitleSection';
import Typography from '../../../components/common/Typography';

import OtherCardItems from './OtherCardItems';
import Type1 from './Type1';
import Type2 from './Type2';
import Type3 from './Type3';
import Type4 from './Type4';
import Type5 from './Type5';

import Type1Detail from './detail/Type1';
import Type2Detail from './detail/Type2';
import Type3Detail from './detail/Type3';
import Type4Detail from './detail/Type4';
import Type5Detail from './detail/Type5';

import {
  getOtherDeductionsData,
  getOtherDeductionsData1,
  getOtherDeductionsData2,
  getOtherDeductionsData3,
  getOtherDeductionsData4,
  getOtherDeductionsData5,
} from './otherDeductionsSlice';

const OtherDeductions = () => {
  const initialIsOpen = {
    type1: false,
    type2: false,
    type3: false,
    type4: false,
    type5: false,
  };
  const dispatch = useDispatch();
  const { t } = useTranslation('deductions/other');
  const navigate = useNavigate();
  const { s11Data, isRender, s11_5total } = useSelector(state => state.otherDeductions);
  const [isOpen, setIsOpen] = useState({
    type1: false,
    type2: false,
    type3: false,
    type4: false,
    type5: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      const result = await dispatch(getOtherDeductionsData());
      const { htmSType, htmJType, htm013 } = result.payload;
      //연금저축
      if (htmSType === '1') {
        dispatch(getOtherDeductionsData1());
        //장기집합
        console.log('htm013', htm013);
        if (Number(htm013) <= 80000000) {
          dispatch(getOtherDeductionsData2());
        }
      }

      dispatch(getOtherDeductionsData3());
      dispatch(getOtherDeductionsData4());
      dispatch(getOtherDeductionsData5());
    };

    fetchData();
  }, []);

  const handleAddButton = type => {
    let _isOpen = initialIsOpen;

    _isOpen[type] = true;

    setIsOpen(_isOpen);
  };

  const handleClose = type => {
    setIsOpen(initialIsOpen);
  };

  return (
    <OtherDeductionsStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />
      <SubTitleSection title={t('title')} img={titleImg} />
      {Number(s11Data.htm013) > 80000000 && (
        <div>
          <Typography variant="body2Medium" color="GrayScale-700">
            {t('description')}
          </Typography>
        </div>
      )}

      {/* 추가버튼들 */}
      <OtherCardItems s11Data={s11Data} handleAddButton={handleAddButton} />
      {/* 하단내용*/}
      {s11Data?.htmSType === '1' && (
        <>
          {/* 연금저축 */}
          <Type1 handleAddButton={() => handleAddButton('type1')} />
          {/* 장기집합 */}
          {Number(s11Data.htm013) <= 80000000 && (
            <Type2 handleAddButton={() => handleAddButton('type2')} />
          )}
        </>
      )}
      {/* 투자조합 */}
      <Type3 handleAddButton={() => handleAddButton('type3')} />
      {/* 소기업, 소상공인 */}
      <Type4 handleAddButton={() => handleAddButton('type4')} />
      {/* 세액공제 */}
      {s11_5total > 0 && <Type5 handleAddButton={() => handleAddButton('type5')} />}

      {/* detail 슬라이드 */}
      <Type1Detail isOpen={isOpen.type1} onClose={handleClose} />
      <Type2Detail isOpen={isOpen.type2} onClose={handleClose} />
      <Type3Detail isOpen={isOpen.type3} onClose={handleClose} />
      <Type4Detail isOpen={isOpen.type4} onClose={handleClose} />
      <Type5Detail isOpen={isOpen.type5} onClose={handleClose} />
    </OtherDeductionsStyled>
  );
};

export default OtherDeductions;
